// extracted by mini-css-extract-plugin
export default {"footer-section":"FooterSection_footer-section__F7N4l","contact-us-wrapper":"FooterSection_contact-us-wrapper__MunP-","footer-main-wrapper":"FooterSection_footer-main-wrapper__gtYIw"};